module.exports = __webpack_public_path__ + "img/ckd2-icon.e4d2e0fe.png";